import urlApiV2 from '@/router/urlApiV2'
import Vue from 'vue'
import Toast from 'vue-toasted'

Vue.use(Toast)
export default {

    async getAulas(data, callback) {
        Vue.http.get(`${urlApiV2}/aulas/praticas/relatorio/pendentes-rejeitadas?schema=${data.schema}&aluno=${data.aluno}&instrutor=${data.instrutor}&periodoI=${data.dataInicio}&periodoF=${data.dataFim}`)
            .then(response => {
                callback(response.body);
            })
            .catch(error => {
                this.launchToast('fa-warning', error.body.dados);

                callback(error.body);
            })
    },
    launchToast(icon, msg) {
        Vue.toasted.show(msg, {
                icon: icon,
                position: 'top-right',
                duration: 5000,
                fullWidth: false
            }
        )
    },
}